// Jedina mapa okruhu prijemcu posily (hodnota z BE -> popisky). Pouziva ji
// vyber v NotifikaceTab i log posil v detailu udalosti, aby se pri nove hodnote
// nemusela hledat vsechna mista.
export const POSILA_PRIJEMCI = [
    { value: 'ALL', menuLabel: 'Všichni', logLabel: 'Všem' },
    { value: 'JEDU', menuLabel: 'Pouze JEDU', logLabel: 'JEDU' },
    { value: 'NEJEDU', menuLabel: 'Pouze NEJEDU', logLabel: 'NEJEDU' },
    { value: 'ZALOHA', menuLabel: 'Pouze v záloze', logLabel: 'V záloze' },
] as const;

export const posilaPrijemciLogLabel = (value?: string | null): string =>
    POSILA_PRIJEMCI.find((p) => p.value === value)?.logLabel ?? 'Vlastní';
